import React from 'react'
import Button, { ButtonType } from '../../Button'
import Icon, { IconType } from '../../Icon'
import componentStyle from './AnnouncementsSuccess.module.scss'
import styles from '@bt-react/styles'
import { AnnouncementsSuccessProps } from './../types'

const AnnouncementsSuccess: React.FC<AnnouncementsSuccessProps> = ({ announcementText, onClick }) => {

  return <div className={ componentStyle['announcements-announcementssuccess-container']} data-bdd="announcements-announcementssuccess-container">
    <div className={ componentStyle['announcementssuccess-sec']}>
      <div className={` ${styles['row']} ${componentStyle['success-sec']} `}>
        <div className={` ${styles['col-1']} ${componentStyle['success-icon']}`}>
          <Icon name={ IconType.iconName.tick } colour={IconType.colour.brightTALK} className={ componentStyle['tick'] } />
        </div>
        <div className={` ${styles['col-11']} ${componentStyle['success-message']} `}>
          <div>Announcement now displaying to your live audience:</div>
          <div className={ styles['mt-3'] }><strong>{announcementText}</strong></div>
        </div>
      </div>
      <div className={ componentStyle['success-buttons']}>
        <Button
          type={ ButtonType.buttonType.button }
          onClick={onClick}
          text="Stop displaying"
          data-bdd="announcement-success"
          className={ componentStyle['button'] }
        />
      </div>
    </div>
  </div>

}

export default AnnouncementsSuccess
